import React, {useEffect, useState} from "react";
import "./dataStatic.style.scss";

export default function StaticPageData(props) {

  return (
    <div className="tmex-static-page-data">
      <div className='content'>
        <h1 className='title'>{props.title}</h1>
        <div className='my-container'>
          <div className='image-container'>
            <img src={props.image} alt='terms'/>
          </div>
          <div className='detail'>
            {props.children}
          </div>
        </div>
      </div>
    </div>
  );
}
